export const FETCH_VIDEO_REQUEST                    = 'FETCH_VIDEO_REQUEST';
export const FETCH_VIDEO_SUCCESS                    = 'FETCH_VIDEO_SUCCESS';
export const FETCH_VIDEO_FAILURE                    = 'FETCH_VIDEO_FAILURE';
export const UPDATE_VIDEOSTATES_REQUEST             = 'UPDATE_VIDEOSTATES_REQUEST';
export const UPDATE_VIDEOSTATES_SUCCESS             = 'UPDATE_VIDEOSTATES_SUCCESS';
export const UPDATE_VIDEOSTATES_FAILURE             = 'UPDATE_VIDEOSTATES_FAILURE';
export const FETCH_VIDEOSTATES_FAILURE              = 'FETCH_VIDEOSTATES_FAILURE';
export const FETCH_VIDEOSTATES_SUCCESS              = 'FETCH_VIDEOSTATES_SUCCESS';
export const FETCH_VIDEOSTATES_REQUEST              = 'FETCH_VIDEOSTATES_REQUEST';
export const UPDATE_VIDEOSTATES                     = 'UPDATE_VIDEOSTATES';